























import {Vue, Component, Prop, Emit} from 'vue-property-decorator'
import {SceneShot} from '@/store/shots'
import {CameraTrack} from '@/store/camera-tracks'
import {cameraTrackStore, shotStore} from '@/store'
import CameraTrackChooser from '@/components/NGL/CameraTrackChooser.vue'
import VuePerfectScrollbar from "vue-perfect-scrollbar"

@Component({
  name: 'CameraTrackDialog',
  components: {CameraTrackChooser, VuePerfectScrollbar},
})
export default class CameraTrackDialog extends Vue {
  @Prop()
  shot!: SceneShot

  dialogOpen = false
  cameraTrack: CameraTrack | null = null

  private async init() {
    if (!cameraTrackStore.cameraTracks.length)
      await cameraTrackStore.loadCameraTracks()
    if (this.shot.cameraTrackId) {
      const camTrack = cameraTrackStore.cameraTracks.find((ct: CameraTrack) => ct.id === this.shot.cameraTrackId)
      if (camTrack)
        this.cameraTrack = camTrack
    }
  }

  async created() {
    await this.init()
  }

  dialogToggle() {
    this.dialogOpen = !this.dialogOpen
    if (this.dialogOpen)
      this.init()
  }

  selectTrack(track: CameraTrack) {
    this.cameraTrack = track
  }

  async selectAndApplyTrack(track: CameraTrack) {
    this.selectTrack(track)
    await this.importCameraTrack()
  }

  @Emit('reloadSceneCameraTrack')
  async importCameraTrack() {
    if (this.cameraTrack) {
      await shotStore.changeSceneShotCameraTrack({shot: this.shot, selected: this.cameraTrack})
      this.dialogToggle()
      return this.cameraTrack
    }
    return ''
  }
}
